import { render, staticRenderFns } from "./CaseNodeNavigatorLabel.vue?vue&type=template&id=dbed5632&scoped=true&"
import script from "./CaseNodeNavigatorLabel.vue?vue&type=script&lang=js&"
export * from "./CaseNodeNavigatorLabel.vue?vue&type=script&lang=js&"
import style0 from "./CaseNodeNavigatorLabel.vue?vue&type=style&index=0&id=dbed5632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbed5632",
  null
  
)

export default component.exports